import $ from 'jquery';

import tasksOverview from './TasksOverviewReact.directive';

routesConfig.$inject = ['$stateProvider'];

export function routesConfig($stateProvider) {
  $stateProvider
    .state('tasks', {
      url: '/tasks',
      template: `<div ${tasksOverview.htmlName}></div>`,
    })
    .state('tasks.leadpopup', {
      url: '/leadpopup/:id',
      onEnter() {
        $('.mdl-js-layout').addClass('-sidebar_expanded');
        $('.l-sidebar').css({ 'z-index': 100 });
      },
      onExit() {
        $('.mdl-js-layout').removeClass('-sidebar_expanded');
        $('.l-sidebar').css({ 'z-index': '' });
      },
    })
    .state('tasks.unitpopup', {
      url: '/unitpopup/:id',
      onEnter() {
        $('.mdl-js-layout').addClass('-sidebar_expanded');
        $('.l-sidebar').css({ 'z-index': 100 });
      },
      onExit() {
        $('.mdl-js-layout').removeClass('-sidebar_expanded');
        $('.l-sidebar').css({ 'z-index': '' });
      },
    });
}
